import { gql } from '@apollo/client';
import { BizAoiProduceResult, PRODUCE_RESULT_FIELDS } from './produceResult';

/**
 * 更新 AOI 基础信息 (名称 / 类型 / 生效状态)。
 *
 * <p>生效状态 未生效→已生效 服务端会做互斥校验, 冲突时 success=false 且带 conflictAoiIds (与编辑形状同一套标红流程)。
 */
export const UPDATE_BIZ_AOI_BASIC = gql`
  mutation UpdateBizAoiBasic($input: BizAoiBasicUpdateInput!) {
    updateBizAoiBasic(input: $input) {
${PRODUCE_RESULT_FIELDS}
    }
  }
`;

export interface BizAoiBasicUpdateInput {
    aoiId: number;
    zipcode: string;
    name?: string | null;
    typeCode?: string | null;
    /** 生效状态 (人工审核结果): 1=已生效 / 0=未生效; null=不更新。 */
    status?: number | null;
}

export interface UpdateBizAoiBasicResponse {
    updateBizAoiBasic: BizAoiProduceResult;
}
